import styled from "styled-components";

const TopNavWrap = styled.div`
background-color: #9701fc;
hover: #f7ce07;
  
  // text-align: center;
  // padding-top: 18px;
  // padding-bottom: 18px;
  
   p {
    //  margin-top: 24px;
    //  margin-bottom: 18px;
    //  font-size: 16px;
    //  font-weight: 600;
    //  color: #ffffff;
  //   //letter-spacing: 3px;
  //   //text-transform: uppercase;
  // 
  // a {
  //   :hover, &.active {
  //     color:rgb(181, 30, 30);
  //   }
}
`

export default TopNavWrap